import PropTypes from "prop-types";

export const accountType = PropTypes.shape({
  id: PropTypes.string,
  label: PropTypes.string,
  slug: PropTypes.string
});

export const addressType = PropTypes.shape({
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  name: PropTypes.string,
  surname: PropTypes.string,
  streetLine1: PropTypes.string,
  streetLine2: PropTypes.string,
  city: PropTypes.string,
  region: PropTypes.string,
  postcode: PropTypes.string,
  country: PropTypes.string
});

export const cardNumberType = PropTypes.shape({
  name: PropTypes.string,
  lastFourDigits: PropTypes.string
});

export const categoryType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string
});

export const currencyType = PropTypes.shape({
  code: PropTypes.string,
  symbol: PropTypes.string
});

export const envelopeType = PropTypes.shape({
  code: PropTypes.string,
  status: PropTypes.string
});

export const focusedDocumentType = PropTypes.shape({
  id: PropTypes.string,
  processingState: PropTypes.string,
  type: PropTypes.string,
  vendor: PropTypes.string
});

export const momentType = PropTypes.shape({
  _d: PropTypes.date,
  format: PropTypes.func
});

export const paginationType = PropTypes.shape({
  limit: PropTypes.number,
  page: PropTypes.number,
  totalResults: PropTypes.number
});

export const paymentTypeType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    type: PropTypes.string,
    lastFourDigits: PropTypes.string
  })
]);

export const documentPropType = PropTypes.shape({
  id: PropTypes.string,
  issued: PropTypes.string,
  modified: PropTypes.string,
  processingState: PropTypes.string,
  source: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
  uploaded: PropTypes.string,
  vendor: PropTypes.string,
  viewed: PropTypes.bool
});

export const documentFiltersType = PropTypes.shape({
  endDate: momentType,
  limit: PropTypes.number,
  processingState: PropTypes.string,
  orderDirection: PropTypes.string,
  orderBy: PropTypes.string,
  startDate: momentType,
  selectedVendors: PropTypes.arrayOf(PropTypes.string),
  totalMin: PropTypes.string,
  totalMax: PropTypes.string,
  viewed: PropTypes.bool
});

export const rowType = PropTypes.shape({
  currency: PropTypes.string,
  id: PropTypes.string,
  invoiceNumber: PropTypes.string,
  issued: PropTypes.string,
  tax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  vendor: PropTypes.string
});

export const userType = PropTypes.shape({
  email: PropTypes.string,
  firstName: PropTypes.string,
  id: PropTypes.string,
  lastName: PropTypes.string
});

export const vendorType = PropTypes.shape({
  name: PropTypes.string
});

export const flashType = PropTypes.shape({
  message: PropTypes.string,
  type: PropTypes.oneOf(["success", "error"])
});

export const selectOptionType = PropTypes.oneOfType([
  PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string
  }),
  PropTypes.string // Empty string
]);

export const reportType = PropTypes.shape({
  documentIds: PropTypes.arrayOf(PropTypes.string),
  exported: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  to: PropTypes.string,
  url: PropTypes.string
});

export const passwordType = PropTypes.shape({
  currentPassword: PropTypes.string,
  newPassword: PropTypes.string,
  newPasswordRepeated: PropTypes.string
});

export const planDetailsType = PropTypes.shape({
  planType: PropTypes.string,
  maxUsers: PropTypes.number,
  subscriptionType: PropTypes.string,
  overageFeePerDocument: PropTypes.string,
  documentLimitPerMonth: PropTypes.number,
  defaultPrice: PropTypes.string,
  totalProcessedCount: PropTypes.number,
  mailinProcessedCount: PropTypes.number,
  digitalProcessedCount: PropTypes.number,
  billableEnvelopeCount: PropTypes.number,
  envelopeLimitPerMonth: PropTypes.number,
  periodStart: PropTypes.string,
  periodEnd: PropTypes.string
});

export const invoiceType = PropTypes.shape({
  createdAt: PropTypes.string,
  currency: PropTypes.string,
  invoiceNumber: PropTypes.number,
  pdfUrl: PropTypes.string,
  state: PropTypes.string,
  tax: PropTypes.number,
  total: PropTypes.number,
  uuid: PropTypes.string
});

export const billingDetailsType = PropTypes.shape({
  expiryMonth: PropTypes.string,
  expiryYear: PropTypes.string,
  lastFourDigits: PropTypes.string,
  name: PropTypes.string,
  surname: PropTypes.string
});

export const reduxFormInputType = PropTypes.shape({
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    momentType,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.bool
  ]).isRequired
});

export const dataType = PropTypes.shape({
  key: PropTypes.string,
  name: PropTypes.string
});

export const uploadType = PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string
});

export const columnObjectType = PropTypes.shape({
  key: PropTypes.string,
  name: PropTypes.string,
  resizable: PropTypes.bool,
  sortable: PropTypes.bool,
  visible: PropTypes.bool
});

export const mergeDocumentType = PropTypes.shape({
  vendor: mergeDocumentItem,
  date: mergeDocumentItem,
  total: mergeDocumentItem,
  tax: mergeDocumentItem,
  category: mergeDocumentItem,
  invoiceNumber: mergeDocumentItem,
  paymentType: mergeDocumentItem
});

const mergeDocumentItem = PropTypes.shape({
  id: PropTypes.string,
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({
      type: PropTypes.string
    }),
    PropTypes.arrayOf(PropTypes.string)
  ])
});

export const gridStyleType = PropTypes.shape({
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  left: PropTypes.number,
  position: PropTypes.string,
  top: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});

export const attachmentType = PropTypes.shape({
  name: PropTypes.string,
  url: PropTypes.string
});

export const routerType = PropTypes.shape({
  params: PropTypes.object
});

export const routeType = PropTypes.shape({
  path: PropTypes.string
});

export const customTabType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  filters: PropTypes.object
});

export const locationType = PropTypes.shape({
  pathname: PropTypes.string
});



// WEBPACK FOOTER //
// ./src/js/custom-prop-types.js